import { requestSync, requestAsync } from './pure/request'

class Connect
{
    constructor()
    {
        this._isConnected = false
        this._watchDog = this._watchDog.bind(this)
    }

    init(router, store)
    {
        this.store = store
        router.beforeEach(this._watchDog)
    }

    _watchDog(to, from, next)
    {
        // Is connected: continue
        if (this.isConnected)
        {
            return next()
        }

        if (to.params.accessToken)
        {
            this.testAccessToken(to.params.accessToken)
        }
        else
        {
            this.testCookieToken()
        }

        if (this.isConnected)
        {
            this.store.connect()

            if (to.name === 'login')
            {
                next({ name: 'slide-01' })
            }
            else
            {
                next()
            }
        }
        else
        {
            if (to.name === 'slide-01')
            {
                next()
            }
            else
            {
                next({ name: 'slide-01' })
            }
        }
    }

    requestToken(emails)
    {
        return requestAsync(process.env.VUE_APP_API_REQUEST_PATH.replace('[emails]', emails.join(',')))
    }

    testAccessToken(token)
    {
        const response = requestSync(process.env.VUE_APP_API_ACCESS_PATH.replace('[token]', token))
        if (response.success)
        {
            this._isConnected = true
            if (response.cookieToken)
            {
                localStorage.setItem('cookieToken', response.cookieToken)
            }
        }
    }

    testCookieToken()
    {
        const token = localStorage.getItem('cookieToken')
        if (token)
        {
            const response = requestSync(process.env.VUE_APP_API_COOKIE_PATH.replace('[token]', token))
            if (response.success)
            {
                this._isConnected = true
            }
        }
    }

    get isConnected()
    {
        return this._isConnected
    }
}

const connect = new Connect()

export default connect
